import React, { useState } from 'react';
import Swal from 'sweetalert2';
import { emailRegex, FormState, phoneRegex } from '@opu/utils';
import AxiosInstance from '../../../helpers/AxiosInstance';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

const useForm = () => {
  const history = useHistory();
  const { t, i18n } = useTranslation();
  const [loading, setLoading] = useState(false);

  const back = () => {
    history.goBack();
  };

  const createEstablishment = () => {
    const formData = new FormData();

    formData.append('name', formState.inputValues.name);
    formData.append('category', formState.inputValues.category);
    formData.append('region', formState.inputValues.region);
    formData.append('email', formState.inputValues.email);
    formData.append('phone', formState.inputValues.phone);
    formData.append('image', formState.inputValues.image);
    setLoading(true);

    AxiosInstance({
      method: 'post',
      url: '/establishment',
      data: formData,
      headers: { 'Content-Type': 'multipart/form-data' },
    })
      .then((response) => {
        Swal.fire(t('establishment.SUCCESS_CREATE_ESTABLISHMENT'), '', 'success');
        resetFormState();
      })
      .catch((error) => {
        if (error.status === 400) {
          handleErrorsServer(error.data.message);
        } else Swal.fire(t('establishment.ERROR_CREATE_ESTABLISHMENT'), '', 'error');
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const inputValues = {
    name: { value: '', validate: { required: true } },
    category: { value: '', validate: { required: true } },
    region: { value: '', validate: { required: true } },
    email: { value: '', validate: { required: true, pattern: emailRegex } },
    phone: { value: '', validate: { required: true, pattern: phoneRegex } },
    image: { value: '', validate: { required: false } },
  };

  const { formState, submitHandler, resetFormState, field, handleErrorsServer } = FormState(inputValues, createEstablishment);

  return {
    submitHandler,
    resetFormState,
    loading,
    field,
    back,
  };
};

export default useForm;
